import { QueryClient } from "@tanstack/react-query";
import { HTTPError } from "griptonite-api-client/client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      retry: (failureCount, error) => {
        if (
          error instanceof HTTPError &&
          (error.response.status === 404 ||
            error.response.status === 403 ||
            error.response.status === 400)
        ) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});
declare global {
  interface Window {
    queryClient: QueryClient;
  }
}

window.queryClient = queryClient;

export default queryClient;
